import { ICityApiItem, IUpsertCityApiPayload } from "models/axiosModel"

export type ConfigurationCity = {
    city_id: number
    city_name: string
    flag_active: boolean
}

export const CITY_FILTER_ACCESSORS = {
    status: (row: ConfigurationCity) => (row.flag_active ? "Active" : "Inactive"),
}

export const CITY_FILTER_GROUPS = [
    {
        key: "status",
        label: "Status",
        options: [
            { label: "Active", value: "Active" },
            { label: "Inactive", value: "Inactive" },
        ],
    },
]

export const citySearchFields = [(r: ConfigurationCity) => r.city_name]

export const mapCityApiItemToConfigurationCity = (item: ICityApiItem): ConfigurationCity => ({
    city_id: item.city_id,
    city_name: item.city_name,
    flag_active: item.flag_active,
})

export const buildAddCityPayload = (fields: { cityName: string; flagActive: boolean }): IUpsertCityApiPayload => ({
    city_name: fields.cityName.trim(),
    flag_active: fields.flagActive,
})

export const buildUpdateCityPayload = (
    city: ConfigurationCity,
    fields: { cityName: string; flagActive: boolean },
): IUpsertCityApiPayload => ({
    city_id: city.city_id,
    city_name: fields.cityName.trim(),
    flag_active: fields.flagActive,
})

export const buildCityStatusPayload = (city: ConfigurationCity): IUpsertCityApiPayload => ({
    city_id: city.city_id,
    flag_active: !city.flag_active,
})

export const cityNameError = (value: string): string | undefined =>
    value.trim() ? undefined : "City name is required"

export const cityNameDuplicateError = (
    value: string,
    existingCities: ConfigurationCity[],
    excludeCityId?: number,
): string | undefined => {
    const normalized = value.trim().toLowerCase()
    if (!normalized) return undefined
    const isDuplicate = existingCities.some(
        (city) => city.city_id !== excludeCityId && city.city_name.trim().toLowerCase() === normalized,
    )
    return isDuplicate ? "A city with this name already exists" : undefined
}
